import { Role } from '../types'
import organizations from './organizations'

const roles: { [key: string]: Role } = {
  gameStartRole: {
    title: 'Founder, CTO',
    organization: organizations.gameStart
  },
  gameChangerRole: {
    title: 'CTO',
    organization: organizations.gameChanger
  },
  saagaraRole: {
    title: 'Team Lead',
    organization: organizations.saagara
  },
  magicLeapRole: {
    title: 'Senior Developer Evangelist',
    organization: organizations.magicLeap
  }
}
export default roles
